export function getAge(dateString) {
	var now = new Date();

	var yearNow = now.getYear();
	var monthNow = now.getMonth();

	var dob = new Date(dateString);

	var yearDob = dob.getYear();
	var monthDob = dob.getMonth();
	var age = {};
	var ageString = '';
	var yearString = '';
	var monthString = '';
	// var dayString = '';
	// console.log('debug date conversion', { dateString, dob, now });
	var yearAge = yearNow - yearDob,
		monthAge;

	if (monthNow >= monthDob) monthAge = monthNow - monthDob;
	else {
		yearAge--;
		monthAge = 12 + monthNow - monthDob;
	}

	age = {
		years: yearAge,
		months: monthAge,
	};
	// console.log('debug computed age', age);

	if (age.years > 1) yearString = ' years';
	else yearString = ' year';
	if (age.months > 1) monthString = ' months';
	else monthString = ' month';

	ageString = age.years + yearString + ', ' + age.months + monthString;

	return ageString;
}
